import { useTranslation } from 'react-i18next';
import { DownloadIcon } from '@src/components/icons/DownloadIcon';
import type { FileInfo } from '@lub0v/santa-utils';
import { onAttachmentDownloadClick, isImageAttachment } from './attachmentDownload';

export function MessageAttachment({
  file,
  onImageLoad,
  compact = false,
}: {
  file: FileInfo;
  onImageLoad?: () => void;
  compact?: boolean;
}) {
  const { t } = useTranslation();
  let url: URL;
  try {
    url = new URL(file.url, window.location.origin);
  } catch {
    return null;
  }
  if (url.protocol !== 'https:' && url.protocol !== 'http:') return null;
  if (!compact && !isImageAttachment(file.filename, file.url)) return null;
  return (
    <a
      className={compact ? 'messenger__download' : 'messenger__attachment'}
      aria-label={compact ? t('game.messenger.download', { name: file.filename }) : undefined}
      title={compact ? t('game.messenger.download', { name: file.filename }) : undefined}
      href={url.href}
      download={file.filename}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(event) => onAttachmentDownloadClick(event, url.href, file.filename)}
    >
      {compact ? <DownloadIcon /> : <img src={url.href} alt={file.filename} onLoad={onImageLoad} />}
    </a>
  );
}
